var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.step=='implementation')?_c('div',{staticClass:"implementation"},[(_vm.data.text)?_c('div',{staticClass:"implementation__text",domProps:{"innerHTML":_vm._s(_vm.data.text)}}):_vm._e(),(_vm.data.btnText)?_c('router-link',{staticClass:"implementation__btn",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.data.btnText))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }